import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
})
export class AppSidebarComponent {
  readonly workspaceNavigation = true;

  @ViewChild('menuContainer') menuContainer!: ElementRef;
  constructor(
    public layoutService: LayoutService,
    public el: ElementRef
  ) {}
}
